import { Controller } from "@hotwired/stimulus";
import { useClickOutside } from "stimulus-use";

export default class extends Controller {
  static targets = ["container", "closeButton", "backdrop"];

  connect() {
    this.opened = false;
    useClickOutside(this);
  }

  open() {
    if (this.opened) return;
    this.opened = true;
    // Provisoire : On ferme tous les autres dialogs
    const otherDialogs = document.querySelectorAll("[data-controller=dialog]");
    otherDialogs?.forEach((dialog) => {
      const id = dialog.getAttribute("id");
      if (id) {
        window.closeDialog(id);
      } else {
        dialog.querySelector("dialog")?.close();
      }
    });
    this.element.focus();

    this.backdropTarget.classList.remove("hidden");
    this.containerTarget.classList.remove("translate-x-full");
    this.closeButtonTarget.classList.remove("hidden");
  }

  close() {
    if (!this.opened) return;
    this.opened = false;
    this.backdropTarget.classList.add("hidden");
    this.containerTarget.classList.add("translate-x-full");
    this.closeButtonTarget.classList.add("hidden");
  }

  clickOutside(event) {
    if (this.opened) {
      this.close();
      event.stopPropagation();
    }
  }
}
